import React from 'react';
import { Button } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';

const styles = theme => ({
    button: {
        display: 'inline-block',
        verticalAlign: 'bottom',
        textAlign: 'center',
        fontSize: '14px',
        lineHeight: '1px',
        height: '32px',
        width: '120px',
        border: '1px solid',
        borderRadius: '3px',
        outline: 0,
        margin: '8px',
        borderColor: '#666',
        color: '#666',
        cursor: 'pointer',
        overflow: 'hidden',
        position: 'relative',
        '&:hover': {
            backgroundColor: '#ccc'
        },
        '&:+.button': {
            marginLeft: 0
        }
    },
    buttonSecondary: {
        backgroundColor: '#666',
        borderColor: '#666',
        color: '#fff',
        '&:hover': {
            backgroundColor: '#444',
            borderColor: '#444'
        }
    },
    buttonPrimary: {
        backgroundColor: '#4ac789',
        borderColor: '#4ac789',
        color: '#fff',
        '&:hover': {
            backgroundColor: '#3ba770',
            borderColor: '#3ba770'
        }
    },
});

const propTypes = {
};

class Footer extends React.Component {

    handleKeyDown(e) {
        if(this.props.keyDownEscFlag == false){
             // Enter
            if (e.keyCode == 13) {
                //処理未設定
            // esc
            } else if (e.keyCode == 27) {
                window.close();
            }
        }
    }

    componentDidMount() {
        window.addEventListener('keydown', this.handleKeyDown.bind(this));
    }

    //親コンポーネントを呼び出す
    updateKeyDownEscFlag(bvalue) {
        return this.props.updateKeyDownEscFlag(bvalue);
    }

    //親コンポーネントを呼び出す
    save(){
        return this.props.save();
    }

    render() {

        const { classes } = this.props;

        return (
            <footer className="hp" id="footer">
                <div className="footer_buttons">
                    <div className="col-l">
                        <Button id="btn-cancel" className={classes.button} onClick={() => { window.location.href = this.props.callback }}>キャンセル</Button>
                    </div>
                    <div className="col-r">
                        <Button id="btn-next" className={`${classes.button} ${classes.buttonSecondary}`} onClick={() => { this.save(); }}>保存</Button>
                    </div>
                </div>
            </footer>
        );
    }
}

Footer.propTypes = propTypes;
export default withStyles(styles)(Footer);